import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const StyledButton = styled.button<{ active: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 12px;
	background-color: ${({ active }) =>
		active ? `${tokens.color_primary}17` : tokens.color_white};
	border: 1px solid ${tokens.color_primary};
	border-radius: 6px;
	color: ${tokens.color_primary};
	cursor: pointer;

	&:hover {
		background-color: ${tokens.color_primary}17;
	}
`;
